/**
 * @fileoverview Axios instance for the parent portal (F1).
 *
 * The fifth auth surface, alongside api.js (instructor), studentApi.js
 * (student), orgApi.js (organization) and opsApi.js (Hans staff). Same
 * configuration; it redirects to /parent/login on 401.
 *
 * A 403 is deliberately NOT redirected. The one 403 this API raises is
 * `email_not_verified`, and bouncing that to a login page would land a parent
 * on a form whose credentials are already correct — the thing they need is
 * the code in their inbox, which is what the verify page is for.
 */

import axios from "axios";

import BACKEND_URL from "./backendUrl";

const PUBLIC_PATHS = ["/parent/login", "/parent/signup", "/parent/verify", "/parent/forgot-password", "/parent/reset-password"];

const parentApi = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

parentApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 401 &&
      !PUBLIC_PATHS.some((p) => window.location.pathname.startsWith(p))
    ) {
      window.location.href = "/parent/login";
    }
    return Promise.reject(error);
  }
);

export default parentApi;

/** Human-readable message from an axios error, handling `{code, message}`. */
export function getParentErrorMessage(error, fallback = "Something went wrong") {
  const detail = error.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg || d.message || JSON.stringify(d)).join(", ");
  if (typeof detail.message === "string") return detail.message;
  return fallback;
}
